/**
 * Newsletter Banner Section
 */
class NewsletterBanner {
  constructor(section) {
    this.section = section;
    this.form = section.querySelector('.newsletter-banner__form');
    this.init();
  }

  init() {
    if (!this.form) return;

    this.form.addEventListener('submit', (e) => {
      const emailInput = this.form.querySelector('.newsletter-banner__input');

      if (emailInput && !emailInput.value.trim()) {
        e.preventDefault();
        return false;
      }
    });
  }
}

// Initialize all newsletter banner sections
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-section-type="w-newsletter-banner"]');
  sections.forEach((section) => {
    new NewsletterBanner(section);
  });
});

// Shopify section editor support
if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-section-type="w-newsletter-banner"]');
    if (section) {
      new NewsletterBanner(section);
    }
  });
}

// Expose class globally for dynamic initialization
window.NewsletterBanner = NewsletterBanner;
